import {
  queryList,
  queryListCount,
  batchQueryListCount,
  columnConfig,
  updateColumnConfig,
  updateToDefault,
  downSyncShopData,
  downSyncShopDataCount,
  batchUpdatePrice,
  batchUpdateTitle,
  batchUpdatePic,
  batchUpdateOnSale,
  queryLogsList,
  userImportsImports,
  checkItemStatus,
  checkMultiPlatformItemStatus,
  deleteItem,
  exportPlatformItem,
  getProgress,
  getFastPublishBaseItemId,
  getErpItemLabel,
  addErpItemLabel,
  batchUpdateItemTag,
  batchUpdateDeliveryTime,
  queryDemandTimeByEnv,
  generatePlatformCodeUpload,
  generateNormalPlatformCode,
  saveGeneratedPlatformCode,
  getSaleCalcConfig,
  updateSaleCalcConfig,
  dyReplenishStock,
  dyQueryTree,
  dyQueryTreeCount,
  dyQueryTreeSkuMore,
  batchSaveDouyinReplenishStockAndDeliveryTime,
  batchUpdateSyncStock,
} from "@/api/prod/center/shopGoods.js";

export function requestApi(api,data) {
  return api(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}
// 查询列表
export function queryListApi(data) {
    return requestApi(queryList,data);
}
// 查询商品总数
export function queryListCountApi(data) {
    return requestApi(queryListCount,data);
}
export function batchQueryListCountApi(data) {
    return requestApi(batchQueryListCount,data);
}
// 获取列配置
export function columnConfigApi(data) {
    return requestApi(columnConfig,data);
}
// 更新列配置
export function updateColumnConfigApi(data) {
    return requestApi(updateColumnConfig,data);
}
// 列配置恢复默认
export function updateToDefaultApi(data) {
    return requestApi(updateToDefault,data);
}
export function getErpItemLabelApi(data) {
    return requestApi(getErpItemLabel,data);
}
export function addErpItemLabelApi(data) {
    return requestApi(addErpItemLabel,data);
}
export function batchUpdateItemTagApi(data) {
    return requestApi(batchUpdateItemTag,data);
}
// 同步店铺数据
export function downSyncShopDataApi(data){
  return requestApi(downSyncShopData,data);
}
// 店铺同步时间
export function userImportsImportsApi(data){
  return requestApi(userImportsImports,data);
}
// 同步店铺数据进度
export function downSyncShopDataCountApi(data){
  return requestApi(downSyncShopDataCount,data);
}
// 批量更新价格
export function batchUpdatePriceApi(data){
  return requestApi(batchUpdatePrice,data);
}
// 批量更新标题
export function batchUpdateTitleApi(data){
  return requestApi(batchUpdateTitle,data);
}
// 批量更新商品主图
export function batchUpdatePicApi(data){
  return requestApi(batchUpdatePic,data);
}
// 批量上下架
export function batchUpdateOnSaleApi(data){
  return requestApi(batchUpdateOnSale,data);
}
// 校验平台商品状态
export function checkItemStatusApi(data){
  return requestApi(checkItemStatus,data);
}
export function checkMultiPlatformItemStatusApi(data){
  return requestApi(checkMultiPlatformItemStatus,data);
}
// 批量删除平台商品
export function deleteItemApi(data){
  return requestApi(deleteItem,data);
}
// 平台商品导出Excel
export function exportPlatformItemApi(data){
  return requestApi(exportPlatformItem,data);
}
// 批量操作进度接口
export function getProgressApi(data){
  return requestApi(getProgress,data);
}
// 日志列表
export function queryLogsListApi(data){
  return requestApi(queryLogsList,data);
}
// 快速铺货-获取baseItemId
export function getFastPublishBaseItemIdApi(data){
  return requestApi(getFastPublishBaseItemId,data);
}
// 批量修改发货时效
export function batchUpdateDeliveryTimeApi(data){
  return requestApi(batchUpdateDeliveryTime,data);
}
// 获取不同环境下某个功能的上线时间(给新功能打上new标识用的)
export function queryDemandTimeByEnvApi(data){
  return requestApi(queryDemandTimeByEnv,data);
}
// 自动生成平台编码并上传平台
export function generatePlatformCodeUploadApi(data){
  return requestApi(generatePlatformCodeUpload,data);
}
// 普通生成平台编码（不上传）
export function generateNormalPlatformCodeApi(data){
  return requestApi(generateNormalPlatformCode,data);
}
// 保存生成的编码（不上传）
export function generateItemCodeSaveApi(data){
  return requestApi(saveGeneratedPlatformCode,data);
}
// 查询店铺商品销量配置
export function getSaleCalcConfigApi(data){
  return requestApi(getSaleCalcConfig,data);
}
// 更新店铺商品销量配置
export function updateSaleCalcConfigApi(data){
  return requestApi(updateSaleCalcConfig,data);
}
// 获取抖音平台库存策略
export function dyReplenishStockApi(data){
  return requestApi(dyReplenishStock,data);
}
// 获取商品列表树型结构(包含sku)
export function dyQueryTreeApi(data){
  return requestApi(dyQueryTree,data);
}
// 获取商品总数
export function dyQueryTreeCountApi(data){
  return requestApi(dyQueryTreeCount,data);
}
// 获取单个商品下全部sku
export function dyQueryTreeSkuMoreApi(data){
  return requestApi(dyQueryTreeSkuMore,data);
}
// 批量执行修改库存、发货时效
export function batchSaveDouyinReplenishStockAndDeliveryTimeApi(data){
  return requestApi(batchSaveDouyinReplenishStockAndDeliveryTime,data);
}
// 批量开启/关闭同步库存
export function batchUpdateSyncStockApi(data){
  return requestApi(batchUpdateSyncStock,data);
}
